import React from 'react'
import { Container } from '@/components/utils'
import {
  BillboardCard,
  BillboardCardProps,
} from '@/components/elements/BillboardCard'

const getMonth = (date: number): string =>
  ({
    1: 'Gener',
    2: 'Febrer',
    3: 'Març',
    4: 'Abril',
    5: 'Maig',
    6: 'Juny',
    7: 'Juliol',
    8: 'Agost',
    9: 'Setembre',
    10: 'Octubre',
    11: 'Novembre',
    12: 'Desembre',
  }[new Date(date).getMonth() + 1])

export interface CinemaBillboardProps {
  currentMovie?: BillboardCardProps
  soonerMovies?: BillboardCardProps[]
  previousMovies?: BillboardCardProps[]
}

export const CinemaBillboard: React.FC<CinemaBillboardProps> = ({
  currentMovie,
  soonerMovies,
  previousMovies,
}) => {
  const todayMonth = getMonth(new Date().getTime()).toLowerCase()

  if (currentMovie || soonerMovies?.length || previousMovies?.length) {
    return (
      <Container className="grid gap-y-5 grid-cols-1 my-10 w-full md:gap-x-5 md:gap-y-0 md:grid-cols-3 md:my-20">
        <div className="flex flex-col flex-wrap col-span-1 mb-5 text-sm font-bold uppercase md:flex-row md:col-span-3 md:text-3xl md:font-black md:normal-case">
          {currentMovie && (
            <div className="flex w-full md:w-1/3">{`Aquest ${todayMonth}`}</div>
          )}
          {soonerMovies?.length > 0 && (
            <div className="hidden w-full md:flex md:w-2/3">Properament</div>
          )}
        </div>
        {currentMovie && <BillboardCard {...currentMovie} />}

        {soonerMovies?.length > 0 && (
          <div className="mb-5 w-full text-sm font-bold uppercase md:hidden">
            Properament
          </div>
        )}
        {soonerMovies?.length > 0 &&
          soonerMovies
            .slice(0, 2)
            .map((movie) => <BillboardCard {...movie} key={movie.id} />)}

        {previousMovies?.length > 0 && (
          <div className="col-span-1 mb-5 text-sm font-bold uppercase md:col-span-3 md:text-3xl md:font-black md:normal-case">
            Anteriorment
          </div>
        )}
        {previousMovies?.length > 0 &&
          previousMovies.map((movie) => (
            <BillboardCard {...movie} key={movie.id} />
          ))}
      </Container>
    )
  }
  return null
}
